import React from 'react'
import { connect } from 'react-redux'
import ErrorBoundary from '@/components/ErrorBoundary'
import { AppDialog } from '@/components/appDialog/appDialog'
import context from '@/context'
import { localized } from '@/decorators/localized'
import { Version } from '@/components/version'

@localized()
class Layout extends React.Component {
  render () {
    const Menu = context.menu
    return (
      <React.Fragment key={`${this.props.localeDependentComponentKey}_${this.props.institutionId}`}>
        <Menu />
        <ErrorBoundary>
          {this.props.children}
        </ErrorBoundary>
        <ErrorBoundary>
          <AppDialog />
        </ErrorBoundary>
        <Version />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  institutionId: state.identity.user && state.identity.user.profile.InstitutionId,
  ...ownProps
})

const DefaultLayout = connect(mapStateToProps)(Layout)
export default DefaultLayout



// WEBPACK FOOTER //
// ./src/layouts/Default/index.js